<template>
    <div>
        <v-app-bar app color="primary" dark>
            <v-toolbar-title>Страница не найдена</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn text class="mr-2" v-on:click="$router.go(-1)">
                <span class="mr-2">Вернуться назад</span>
            </v-btn>
        </v-app-bar>
    </div>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>